import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { NavBar } from 'components/NavBar/NavBar'
import { StepNumber } from 'pages/Accomodation/Accommodation.style'
import { BodyText } from 'styling/Typography'
import { NextIcon } from 'pages/Accomodation/icons/NextIcon'
import { useState } from 'react'
import { Identity } from './Sections/Identity'
import { Scope } from './Sections/Scope'
import { Targets } from './Sections/Targets'
import { Phases } from './Sections/Phases'
import { Review } from './Sections/Review'
import { IOperationPlanState } from 'types/operationPlans.interface'
import { Horizon } from './Sections/Horizon'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { useNavigate } from 'react-router-dom'
import { addOperationPlan } from 'features/operations/plansSlice'

export const AddPlan = () => {
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [state, setState] = useState<IOperationPlanState>({
        name: null,
        code: null,
        site: null,
        department: null,
        owner: null,
        zoneScopeLevel: null,
        zoneScopeIds: [],
        priority: null,
        objective: null,
        targetUnit: null,
        targetValue: null,
        targetBudgetCost: null,
        targetCurrencyCode: null,
        dueAt: null,
        boardVisibility: null,
        autoPauseOnL3Plus: null,
        phases: [],
        horizon: {
            horizonType: null,
            schedulerRunFreqMin: null,
            replenishThreshold: null,
            maxQueueSize: null,
        },
    })
    const [step, setStep] = useState(1)

    const handleSave = async () => {
        const resp = await dispatch(addOperationPlan(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(`/operations/plans/${(resp.payload as any).id}`, { replace: true })
        }
    }

    const renderStep = () => {
        switch (step) {
            case 1:
                return <Identity state={state} setStep={setStep} setState={setState} />
            case 2:
                return <Scope state={state} setStep={setStep} setState={setState} />
            case 3:
                return <Targets state={state} setStep={setStep} setState={setState} />
            case 4:
                return <Phases state={state} setStep={setStep} setState={setState} />
            case 5:
                return <Horizon state={state} setStep={setStep} setState={setState} />
            case 6:
                return <Review state={state} setStep={setStep} handleSave={handleSave} />
        }
    }


    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Plan' />
            <Flex gap='1rem' center style={{ margin: '2rem 0' }} >
                <Step pointer step={1} name='Identity' active={step === 1} onClick={() => setStep(1)} />
                <NextIcon />
                <Step step={2} name='Scope' active={step === 2} />
                <NextIcon />
                <Step step={3} name='Targets' active={step === 3} />
                <NextIcon />
                <Step step={4} name='Phases' active={step === 4} />
                <NextIcon />
                <Step step={5} name='Horizon' active={step === 5} />
                <NextIcon />
                <Step step={6} name='Review' active={step === 6} />
            </Flex>
            {renderStep()}
        </PageWrapper>
    </>
}

const Step = ({ step, name, active, onClick, pointer }: { step: number, name: string, active: boolean, onClick?: () => void, pointer?: boolean }) => {
    return <Flex center gap='1rem' onClick={onClick} style={{ cursor: pointer ? 'pointer' : 'default' }} >
        <StepNumber active={active} >  {step}</StepNumber>
        <BodyText grey={!active} >{name}</BodyText>
    </Flex>
}